export default __webpack_public_path__ + "static/media/rafa2.b5ef624f.jpg";